<template v-if="mostrar == true">
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">

              <div class="card card-lg shadow-lg" style="border:1px solid #bdbdbd;">

                      <div class="card-header text-center align-middle bg-primary-dark">
                        <h1 class="card-title h5 text-white" style="">Precio Final</h1>
                        <p class="card-text text-white" style="font-size:9pt; padding-bottom:10px;">Para todos los asegurados</p>

                        <div class="mb-2">
                            <div class="fs-5 text-white" v-if="productoAnterior == true"><del>{{(PrecioProducto*1.20).toFixed(2)}}€</del></div>
                            <span class="display-2 text-white">{{Math.floor(PrecioProducto).toLocaleString('pt-BR', {minimumFractionDigits: 0})}}</span>
                            <span class="fs-3 text-white">,{{((Math.floor(PrecioProducto)-PrecioProducto.toFixed(2))*(-100)).toFixed(0)}}</span>
                            <span class="text-white fs-6">&nbsp;{{PeriodosEscritos[PeriodoSeleccionado]}}</span>

                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row">
                        <ul class="list-checked list-checked-primary">
                          <div class="fs-5 text-center" style="padding-top:10px; padding-bottom:10px;"><b><u>{{nombreProductoPrincipal}}</u></b></div>
                          <p class="card-text text-center" style="padding: 20px; font-style: italic;" v-html="descripcionProductoPrincipal"></p>
                          <li class="list-checked-item" v-for="(feature, index) in caracteristicasProducto" v-html="feature" :key="index"></li>
                        </ul>
                        </div>
                      <template v-for="(product, index2) in datosProductosSecundarios" :key="index2">
                        <div class="row">
                        <ul class="list-checked list-checked-primary">
                            <div class="text-center">➕</div>

                            <div class="fs-5 text-center" style="padding-top:10px; padding-bottom:10px;"><b><u>{{product.name}}</u></b></div>
                            <p class="card-text text-center" style="padding: 20px; font-style: italic;" v-html="product.description"></p>
                            <li class="list-checked-item" v-for="(feature, index3) in product.features" v-html="feature" :key="index3"></li>
                          </ul>
                        </div>
                      </template>
                      </div>
                      <div class="card-footer text-center">
             
                        <div class="d-grid mb-2">
                          <button @click="IrHaciaDelanteFormulario" class="btn btn-primary" style="background: #F78104; border: 1px solid red; color:#000; font-weight: bold;">Continuar</button>
                        </div>
                      <small class="d-block text-muted"><i>Si modifica durante el proceso de contratación, las fechas de nacimiento, la provincia de residencia u otras variables de tarificación de las que inicialmente se indicaron en el presupuesto, la prima de la póliza podría cambiar.</i></small>

                      </div>
              

            </div>

        </div>
    </div>
</template>

<script>

import PricingJS from "./Pricing/Pricing.js"
import Prices from './MatrixPrices'

export default {
  name: 'Pricing',
  props: {

    response: String,
    FormularioTag: String,
    idQuestion: Number,
    PeriodoSeleccionado: String,
    PrecioProducto: Number,
    PeriodosEscritos: Object,
    productoAnterior: Boolean,
    PricingProducts: Array,
    ProductoSeleccionado: String,
    AddonsSeleccionados: Array,
    Precios : Array

  },

  data: function () {
            return {
              caracteristicasProducto: [],
              nombreProductoPrincipal: null,
              datosProductosSecundarios: [],
              ProductosContratados: [],
              descripcionProductoPrincipal: null,
              NumeroProductosSeleccionados: 0,
              mostrar: false
            }
  },

  beforeMount: async function(){

    if (this.ProductoSeleccionado != "" && this.ProductoSeleccionado != null && this.ProductoSeleccionado != null)
    {

      await this.ActualizarDatos();
     
    } else {

      window.location.replace("/calcula-tu-precio/");

    }

  },

  mounted: async function(){


    this.$watch('ProductoSeleccionado', async function () {

      await this.ActualizarDatos();

    });


    if (this.PricingProducts.length >= 1 && this.ProductoSeleccionado != "" && this.ProductoSeleccionado != null && this.ProductoSeleccionado != null)
    {

      let producto = await PricingJS.SearchProduct(this.ProductoSeleccionado, this.PricingProducts);



      if (producto.cod)
      {

        this.nombreProductoPrincipal = producto.name;
        this.caracteristicasProducto = producto.features;
        this.descripcionProductoPrincipal = producto.description; 

        let resumeProduct = {"code": producto.cod, "name": producto.name};
        this.ProductosContratados.push(resumeProduct);

      }


      if (this.AddonsSeleccionados.length >= 1)
      {

        this.datosProductosSecundarios = [];

        for (let productoSecundario of this.AddonsSeleccionados)
        {
        

          let productoSecMatrix = await PricingJS.SearchProduct(productoSecundario, this.PricingProducts);

          if (productoSecMatrix.cod)
          {

              let matrix = {

                "name" : productoSecMatrix.name,
                "description" : productoSecMatrix.description,
                "features" : productoSecMatrix.features
              };

              let resumeProduct = {"code": productoSecMatrix.cod, "name": productoSecMatrix.name};
              this.ProductosContratados.push(resumeProduct);

              this.datosProductosSecundarios.push(matrix);

          }


        }

      }


      if (this.ProductosContratados.length >= 1)
      {

        let Mutation = {

          formulario: this.FormularioTag,
          question: this.idQuestion,
          validate: true,
          response: this.nombreProductoPrincipal,
          price: this.PrecioProducto,
          periodo: this.PeriodoSeleccionado,
          products: this.ProductosContratados,
          count: this.ProductosContratados.length

        };

        dataLayer.push({'conversionValue': this.PrecioProducto});


        await this.$store.commit('actualizarRespuestaFormulario', Mutation);

        this.mostrar = true;

      }



    } else {

      window.location.replace("/calcula-tu-precio/");


    }
  },

  methods: {

    IrHaciaDelanteFormulario : function(){

        this.MostrarTituloSiempre();
        this.$store.commit('IrHaciaDelanteFormulario', this.FormularioTag);


    },


    VolveralPresupuesto : function(){

      if (this.$store.state.idPresupuesto && this.$store.state.presupuestoTipo)
      {

        let paginaParrilla = "/presupuesto?idPresupuesto="+this.$store.state.idPresupuesto;

        window.location.replace(paginaParrilla);

      } else {

        window.location.replace("/calcula-tu-precio/");

      }



    },

    MostrarTituloSiempre: function(){

        window.scrollTo(0, 0);

    },

    ActualizarDatos : async function(){


        this.NumeroProductosSeleccionados = await Prices.NumeroProductosSeleccionados(this.AddonsSeleccionados, this.ProductoSeleccionado);
        let NProductosEnMatriz = (this.NumeroProductosSeleccionados-1);


        let retorno = await Prices.EncontrarPrecio(this.Precios[NProductosEnMatriz], this.ProductoSeleccionado);

        if (retorno[this.PeriodoSeleccionado] > 0)
        {

          //Calculamos los precios de las extensiones
          let extensiones = await Prices.EncontrarPreciosAddons(this.Precios[NProductosEnMatriz], this.AddonsSeleccionados);

          let precioAddons = await Prices.sumarExtensiones(extensiones, this.PeriodoSeleccionado);

          let PrecioProducto = (retorno[this.PeriodoSeleccionado]+precioAddons);
          this.NombreProducto = await Prices.EncontrarNombreProducto(this.Precios[NProductosEnMatriz], this.ProductoSeleccionado);

          await this.$store.commit('ActualizarPrecioFinal', PrecioProducto);


        }

        

    }


  }
}
</script>